import { useQuery } from '@tanstack/react-query';
import * as userManagementApi from '@/services/userManagementApi';
import type { UserManagementDTO } from '@/types/api';

export interface DirectoryUser {
  id: string;
  username: string;
  email: string;
  firstName: string;
  lastName: string;
  department: string;
  title: string;
  status: 'active' | 'inactive';
  lastLogin: string;
  provider: string;
  customer: string;
  groups: string[];
  externalId: string;
  managerEmail?: string;
  attributes: Record<string, any>;
  syncedAt: string;
}

function mapUserToDirectoryUser(u: UserManagementDTO): DirectoryUser {
  return {
    id: u.id || '',
    username: u.username || u.email || '',
    email: u.email || '',
    firstName: u.firstName || '',
    lastName: u.lastName || '',
    department: '',
    title: '',
    status: 'active',
    lastLogin: new Date().toISOString(),
    provider: 'Platform',
    customer: u.tenantId || 'Unknown',
    groups: u.roles || [],
    externalId: u.id || '',
    managerEmail: undefined,
    attributes: {},
    syncedAt: new Date().toISOString(),
  };
}

export const useDirectoryUsers = () => {
  const query = useQuery({
    queryKey: ['directoryUsers'],
    queryFn: async () => {
      const users = await userManagementApi.listUsers();
      return (users || []).map(mapUserToDirectoryUser);
    },
  });

  return {
    users: query.data || [],
    isLoading: query.isLoading,
    error: query.error ? (query.error as Error).message : null,
  };
};
